<template>
  <AccountOpePanel>
    <div class="card">
      <div class="card-header">
        <h5 class="mb-0 h6">{{ $t("申请退款请求") }}</h5>
      </div>
      <div class="card-body">
        <table
          class="table aiz-table mb-0 footable footable-1 breakpoint breakpoint-xs"
          style=""
        >
          <thead>
            <tr class="footable-header">
              <th style="display: table-cell">#</th>
              <th data-breakpoints="lg" style="display: none">
                {{ $t("日期") }}
              </th>
              <th style="display: table-cell">{{ $t("订单编号") }}</th>
              <th data-breakpoints="lg" style="display: none">
                {{ $t("产品") }}
              </th>
              <th data-breakpoints="lg" style="display: none">
                {{ $t("总额") }}
              </th>
              <th style="display: table-cell">{{ $t("状态") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr class="footable-empty">
              <td colspan="3">{{ $t("什么都没找到") }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </AccountOpePanel>
</template>
<script>
import AccountOpePanel from "@/components/AccountOpePanel.vue";

export default {
  components: { AccountOpePanel }
};
</script>
